export async function getTemplateConfigFromHorn(self) {
    const isProd = ['beta', 'staging', 'production'].includes(
        process.env.NODE_ENV,
    );
    const urlPrefix = '//portal-portm.meituan.com/horn/v1/modules';
    const apiName = isProd ? 'prod' : 'test';
    const url = [urlPrefix, 'vss', apiName].join('/');
    const res = await self.$get(url, {}, { parseData: false });
    const {
        printLogoMap,
        printTagTemplate,
        printTagTemplateV2,
        allowLoopTaskTempalte,
        maxPrintNums,
        maxPrintDate,
        supplierWhiteList,
        supplierTaskLenConfig,
    } = res;
    return {
        printLogoMap,
        printTagTemplate,
        printTagTemplateV2,
        allowLoopTaskTempalte,
        maxPrintNums,
        maxPrintDate,
        supplierWhiteList,
        supplierTaskLenConfig,
    };
}


export function getPrinDetailInfo(printData) {
    return [
        { label: 'skuId:', value: printData.skuId },
        { label: '条形码:', value: printData.skuCode },
        { label: '商品名称:', value: printData.spuName },
        { label: '规格:', value: printData.skuSpec },
    ];
}
